import { SVGProps } from 'react';

const Space = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1"
    />
  </svg>
);
export default Space;
